import React from 'react';

const SvgTooltip = (props) => (
  <svg width={12} height={12} {...props}>
    <path
      fill="currentColor"
      d="M6 0a6 6 0 1 0 0 12A6 6 0 0 0 6 0zm.6 9H5.4V5.4h1.2V9zm0-4.8H5.4V3h1.2v1.2z"
      opacity={0.5}
    />
  </svg>
);

export default SvgTooltip;
